<template>
  <div class="c-questions-create">
    <div class="questions-window">
      <n-card class="questions-card">
        <n-loader :loading="$var('load')" />
        <div class="card-top">
          <n-button flat @click="closeModal">X</n-button>
        </div>
        <div>
          <div class="category-info">
            <n-input title="Название вопроса" v-bind="$form.input('title')"></n-input>
            <n-input title="Порядок" v-bind="$form.input('serialNumber')"></n-input>

          </div>
          <div class="category-info">
            <div class="checkbox">
              <div class="box" :class="{'active': isMemo}" @click="isMemo = !isMemo">✓</div>
              <div class="title">Примечание</div>
            </div>
          </div>
          <div class="button-save">
            <n-button color="primary" @click="save">Сохранить</n-button>
          </div>
        </div>
      </n-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CQuestions',
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isMemo: false,
    }
  },
  computed: {},
  created() {
    this.loadQuestion()
  },
  methods: {
    closeModal() {
      this.$emit('update:show', false)
    },
    loadQuestion() {
      this.$var('load', true)
      $api.questions.getOne(this.id).then((response) => {
        this.$form.init(response.data.content)
        this.isMemo = response.data.content.isMemo
      }).finally(() => {
        this.$var('load', false)
      })
    },
    save() {
      this.$var('load', true)
      $api.questions.edit(this.id,{
        title: this.$form.get('title'),
        serialNumber: this.$form.get('serialNumber'),
        isMemo: this.isMemo,
      }).then(() => {
        this.closeModal()
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.c-questions-create {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, .2);

  .questions-card {
    min-width: 700px;
    min-height: 300px;
    position: relative;
  }

  .checkbox {
    display: flex;
    align-items: center;
    margin-top: 10px;
    .box {
      width: 24px;
      height: 24px;
      border: 1px solid black;
      border-radius: 4px;
      color: #ffffff;
      margin-right: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      &.active {
        background-color: var(--primary);
      }
    }
  }
  .button-save {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: right;
  }
  .card-top {
    display: flex;
    align-items: center;
    justify-content: right;
    margin-bottom: 20px;
  }
}
</style>
